module.exports = __webpack_public_path__ + "static/media/logo-credito-real.555a24e9.png";